import { EMAIL_REGEX } from '@constants/common';
import { PHONE_REGEX } from '@constants/schema';
import * as Yup from 'yup';

const MESSAGE_CHAR_LIMIT = 2000;

export const contactFormSchema = Yup.object({
    sender_name: Yup.string().trim().required('This field is required'),
    sender_email: Yup.string()
        .trim()
        .email('Email not valid')
        .required('This field is required')
        .matches(EMAIL_REGEX, 'Email not valid'),
    sender_phone: Yup.string().trim().required('This field is required').matches(PHONE_REGEX, 'Phone number not valid'),
    sender_message: Yup.string()
        .max(MESSAGE_CHAR_LIMIT, `Message length cannot exceed ${MESSAGE_CHAR_LIMIT} characters`)
        .required('This field is required'),
});
